// extracted by mini-css-extract-plugin
export default {"container":"UnAuthorized_container__VgL3f","mainText":"UnAuthorized_mainText__eKF22","card":"UnAuthorized_card__+1hpX","underline":"UnAuthorized_underline__CF4Mk"};